import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useFormBuilder } from '../utils/useFormBuilder';
import { useWorkOrderSchedule } from '../hook/useWorkOrderSchedule';
import { useWorkOrderScheduleFields } from '../hook/useWorkOrderScheduleFields';

const WorkOrderRecurrenceModal = ({ show, onClose, scheduleId, onSaved }) => {

  const { getSchedule, updateSchedule } = useWorkOrderSchedule();
  const [formData, setFormData] = useState(null);
  const [errors] = useState({});
  const [toastMsg, setToastMsg] = useState('');

  useEffect(() => {
    if (!show || !scheduleId) return;
    (async () => {
      try {
        const data = await getSchedule(scheduleId);
        const templateWorkOrderId = Number(
          data.templateWorkOrderId,
        );
        setFormData({ ...data, templateWorkOrderId });
      } catch (err) {
        console.error(err);
      }
    })();
  }, [show, scheduleId, getSchedule]);

  useEffect(() => {
    if (toastMsg) {
      const t = setTimeout(() => setToastMsg(''), 4000);
      return () => clearTimeout(t);
    }
  }, [toastMsg]);

  const scheduleFields = useWorkOrderScheduleFields({
    workOrderSchedule: formData || {},
    setWorkOrderSchedule: setFormData,
    includeActive: false,
  });

  const { renderField } = useFormBuilder(
    scheduleFields,
    formData || {},
    setFormData,
    errors,
  );

  const handleSubmit = async () => {
    if (!scheduleId || !formData) return;
    const payload = {
      templateWorkOrderId: parseInt(formData.templateWorkOrderId, 10),
      recurrencePattern: formData.recurrencePattern,
      intervalValue: parseInt(formData.intervalValue, 10) || 0,
      daysOfWeek: formData.daysOfWeek || null,
      dayOfMonth:
        formData.dayOfMonth != null ? parseInt(formData.dayOfMonth, 10) : null,
      monthOfYear:
        formData.monthOfYear != null
          ? parseInt(formData.monthOfYear, 10)
          : null,
      startDate: formData.startDate
        ? new Date(formData.startDate).toISOString()
        : null,
      endDate: formData.endDate
        ? new Date(formData.endDate).toISOString()
        : null,
      occurrenceCount:
        formData.occurrenceCount != null
          ? parseInt(formData.occurrenceCount, 10)
          : null,
      noEndDate: !!formData.noEndDate,
      active: 1,
    };
    try {
      await updateSchedule(scheduleId, payload);
      setToastMsg('Recurring schedule updated.');
      if (typeof onSaved === 'function') {
        onSaved();
      }
      onClose();
    } catch (err) {
      console.error(err);
      setToastMsg('Failed to update schedule');
    }
  };

  if (!show) return null;

  return (
    <>
      {toastMsg && (
        <div
          className="toast-container position-fixed top-0 start-50 translate-middle-x p-3"
          style={{ zIndex: 2000 }}
        >
          <div className="toast show align-items-center text-bg-success border-0">
            <div className="d-flex">
              <div className="toast-body">{toastMsg}</div>
              <button
                type="button"
                className="btn-close btn-close-white me-2 ms-auto"
                onClick={() => setToastMsg('')}
              ></button>
            </div>
          </div>
        </div>
      )}
      <div className="modal modal-xl modal-backdrop show d-block" tabIndex="-1">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Edit Recurrence</h5>
              <button type="button" className="btn-close" onClick={onClose} />
            </div>
            <div className="modal-body">
              {formData ? (
                <div className="row g-3">{scheduleFields.map(renderField)}</div>
              ) : (
                <div className="d-flex justify-content-center py-4">
                  <span className="spinner-border spinner-border-sm" />
                </div>
              )}
            </div>
            <div className="modal-footer">
              <Button variant="secondary" onClick={onClose}>
                Close
              </Button>
              <Button variant="primary" onClick={handleSubmit}>
                Save
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default WorkOrderRecurrenceModal;

